<script setup>
import DefaultLayout from '~/components/layout/default.vue';
import { useSiteStore } from '~/stores/site.store';
import { globalKeys } from 'assets/data/global-keys';

const { $t, $errorTracking } = useNuxtApp();
const siteStore = useSiteStore();
const route = useRoute();

const { $localeService, $configService, $sitemapService, $storageService } =
  useServices();
// fetches
const localeCookie = $storageService.getCookie({
  key: globalKeys.siteConfigKeys.locale,
});
await $sitemapService.fetchSitemap(siteStore.regionCode);
await $configService.fetchConfig(siteStore.regionCode);
await $configService.fetchRedirects(siteStore.regionCode);
await $localeService.fetchLocale(localeCookie);

const error = useError();

if (!!error) {
  $errorTracking({
    title: error?.value?.statusCode,
    path: error?.value?.statusMessage,
    message: route?.fullPath,
  });
  console.error(error.value);
}

const routeHomeAndClear = () => clearError({ redirect: '/' });
</script>
<template>
  <DefaultLayout>
    <UserInterfaceErrorNotice :show-logo="$viewport.isLessThan('tablet')">
      <template #icon>
        <DesignSystemIconsMaintenanceIcon
          class="!w-20 md:!w-32 relative z-10"
        />
      </template>
      <template #title>
        <span>
          {{ $t(`${error.statusCode}-error-title`) }}
        </span>
      </template>
      <template #message>
        <span>
          {{ $t(`${error.statusCode}-error-message`) }}
        </span>
      </template>
      <template #actions>
        <DesignSystemButton type="primary" @click="routeHomeAndClear">
          {{ $t('back-button') }}
        </DesignSystemButton>
      </template>
    </UserInterfaceErrorNotice>
  </DefaultLayout>
</template>
